import * as ngCore from '@angular/core'
import * as ents from '@attain-apps/entities'
import * as ec from '@attain-apps/fe/web/main/lib/entity-collection'
import * as rxjs from 'rxjs'

import * as common from '../common'
import * as records from '../records'
import * as rules from '../rules'

import type { TypeParams } from './types'

const ATTRIBUTES: ec.models.Attribute<TypeParams>[] = [
  {
    getValueFrom: entry =>
      common.attributes.mapping.getIdcCategoryValue(
        entry.faFunctionCategorization,
      ),
    id: common.attributes.mapping.Id.IdcCategory,
    name: 'Code',
  },
  {
    getValueFrom: entry =>
      common.attributes.mapping.getIdcSubcategoryValue(
        entry.faFunctionCategorization,
      ),
    id: common.attributes.mapping.Id.IdcSubcategory,
    name: 'Sub Code',
  },
  {
    getValueFrom: entry => entry.exclusionLabel,
    id: common.attributes.mapping.Id.ExclusionLabel,
    name: 'Exclusion',
  },
  {
    getValueFrom: entry => entry.percent,
    id: 'percent',
    name: '%',
  },
]

@ngCore.Injectable()
export class Api implements ec.models.Api<TypeParams> {
  /**
   * @see {@link records.Collection}
   */
  private readonly _recordsEc = ngCore.inject(records.Collection)
  /**
   * @see {@link rules.Collection}
   */
  private readonly _rulesEc = ngCore.inject(rules.Collection)

  /** @inheritdoc */
  public list = ec.models.Api.list.using.nothingButContext<TypeParams>(
    context => {
      // TODO: get
      if (!context) {
        // No context = nothing to return
        return rxjs.of([])
      }
      const { recordId, ruleId } = context

      let mapping$:
        | rxjs.Observable<ents.extra.rate.gl.Mapping | undefined>
        | undefined
      if (recordId) {
        // GL Records
        mapping$ = this._recordsEc.plugins.cachePlugin.feature.selectors
          .getCachedEntity(recordId)
          .asObservable.pipe(
            rxjs.switchMap(record =>
              this._rulesEc.plugins.cachePlugin.feature.selectors.lookup.asObservable.pipe(
                rxjs.map(
                  rulesLookup =>
                    record &&
                    ents.extra.rate.gl.Record.getMapping(record, rulesLookup),
                ),
              ),
            ),
          )
      } else if (ruleId) {
        // Rules
        mapping$ = this._rulesEc.plugins.cachePlugin.feature.selectors
          .getCachedEntity(ruleId)
          .asObservable.pipe(rxjs.map(rule => rule?.mapping))
      }

      return (
        mapping$?.pipe(
          rxjs.map(
            mapping =>
              mapping?.entries.map((entry, idx) => ({
                ...entry,
                id: idx.toString(),
              })) ?? [],
          ),
        ) ?? rxjs.of([])
      )
    },
  )

  /** @inheritdoc */
  public getAttributes: ec.models.Api<TypeParams>['getAttributes'] = () =>
    rxjs.of(ATTRIBUTES)
}
